/* eslint-disable max-len */
import React from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { above, below, colors } from '../../style/design-system'
import FormHireUMA from './FormHireUMA'
import FormWrapperGray from './FormWrapperGray'

const ComposedFormHireUMA = ({ className, makeFullWidth }) => {
  const disclaimer = 'By clicking the "Continue" button, you agree to be contacted by phone, text message, or email via automated systems by Ultimate Medical Academy with the information you provide as part of the form. You are not obligated to provide consent to be presented UMA graduates.'

  return (
    <div className={`${className} request-info d-flex flex-column w-100`}>
      <div className={cx(
        'text-center',
        { 'col-12 col-lg-8 offset-lg-2': !makeFullWidth },
        { 'make-full-width': makeFullWidth },
      )}>
        <FormWrapperGray
          disclaimer={disclaimer}
          heading='<span class="h1 mt-0">Request Information</span>'
          showDefaultContent={false}
          columnProps={{ offset: 1, size: 10 }}
          headingTag="h2">
          <p>
            Let us fill your open allied positions with our
            knowledgeable healthcare grads, at no fee.
          </p>
          <FormHireUMA />
        </FormWrapperGray>
      </div>
    </div>
  )
}

ComposedFormHireUMA.propTypes = {
  className: PropTypes.string,
  makeFullWidth: PropTypes.bool,
}

ComposedFormHireUMA.defaultProps = {
  className: undefined,
  makeFullWidth: false,
}

export default styled(ComposedFormHireUMA)`
  background-color: ${colors.dev.gray.h()};
  input { width: 100% !important; }
  .input-wrap {
    ${below.sm`
      padding-left: 0 !important;
      padding-right: 0 !important;
    `}
  }
  .make-full-width .container {
    ${above.md`
      padding-bottom: 0 !important;
      padding-top: 0 !important;
    `}
  }
`
